<template>
  <div>
    <v-row
      v-if="teacher"
      class="main--text"
      justify="start">
      <v-col
        cols=12
        md=4
        sm=4>
        <v-container
          fluid
          class="no--vertical--padding"
          >
          <v-row
            justify=center
            justify-sm=end
            justify-md=end>
            <v-col
              cols=auto>
              <v-avatar size="100px">
                <img :src="teacher.iconUrl" alt="">
              </v-avatar>
            </v-col>
          </v-row>
          <v-row
            justify=center
            justify-sm=end
            justify-md=end>
            <v-col
              cols=auto>
              <h2>{{teacher.fullName()}}</h2>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        cols=12
        md=8
        sm=8>
        <v-container
          fluid
          class="no--vertical--padding"
          >
          <h5>日時</h5>
          <p>
            {{ record.dateString()}}
            <br>
            {{ record.lesson.schedule.toString() }}
          </p>
          <h5>対象のお子さま</h5>
          <p>{{ student.fullName() }}さん</p>
          <h5>報酬</h5>
          <p>{{record.lesson.wage}}円</p>
          <v-row
            justify=center
            justify-sm=end
            justify-md=end>
            <v-col
              cols=auto
              class="no--vertical--padding">
              <v-container
                fluid
                class="no--vertical--padding">
                <v-row
                  align=center
                  justify=center
                  dense>
                  <v-col
                    cols=auto>
                    <v-btn
                      rounded
                      outlined
                      depressed
                      color="grey"
                      @click="isRemove=true">
                      取り消す
                    </v-btn>
                  </v-col>
                  <v-col
                    cols=auto>
                    <v-btn
                      rounded
                      outlined
                      depressed
                      color="primary"
                      @click="openEdit()">
                      修正
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-lesson-record-editor
      v-if="isEdit"
      :enable="isEdit"
      :teacher="teacher"
      :student="student"
      v-model="updateValue"
      @update-button-click="updateRecord"
      @close-button-click="closeEdit"/>
    <v-dialog
      :value="isRemove"
      width="350"
      >
      <v-card
        class="main--text">
        <v-container
          fluid>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              この授業記録を削除してもよろしいですか。
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                rounded
                depressed
                outlined
                @click="isRemove=false">閉じる</v-btn>
            </v-col>
            <v-col
              cols=auto>
              <v-btn
                rounded
                depressed
                outlined
                color="grey"
                @click="removeRecord">削除</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TeacherRepository } from "@/repository/TeacherRepository"
import { firestore } from "@/repository/client/firestore"
import VLessonRecordEditor from '@/components/organisms/parent/VLessonRecordEditor'

export default {
  components: {
    VLessonRecordEditor
  },
  props: {
    record: Object
  },
  data () {
    return {
      teacher: null,
      updateValue: {},
      isEdit: false,
      isRemove: false
    }
  },
  methods: {
    openEdit() {
      this.isEdit = true
    },
    updateRecord() {
      this.$emit('update-button-click', this.updateValue)
      this.isEdit = false
    },
    closeEdit() {
      this.isEdit = false
    },
    removeRecord() {
      this.$emit('remove-button-click', this.record)
      this.isRemove = false
    }
  },
  created: async function () {
    const teacherRepo = new TeacherRepository(firestore)
    this.teacher = await teacherRepo.find(this.record.lesson.teacherId)
    this.updateValue = {...this.record}
  },
  computed: {
    student () {
      return this.$store.getters.parent.findStudent(this.record.lesson.studentId)
    }
  }
}
</script>

<style scoped>
.no--vertical--padding {
  padding: 0px 12px;
}
</style>
